<template>
  <div class="stop-source-drawer__content">
    <p class="stop-source-drawer__title">
      {{$t('feed.settings.stopSource.newSource.title')}}
    </p>
    <el-divider></el-divider>
    <el-form :model="sourceForm" :rules="rules" ref="sourceForm" label-width="120px" class="demo-ruleForm" v-loading="loading" label-position="top">
      <el-form-item :label="$t('feed.settings.stopSource.newSource.form.network_id')" prop="network_id">
        <el-select v-model="sourceForm.network_id" size="small" :placeholder="$t('feed.settings.stopSource.newSource.form.network_placeholder')">
          <el-option
            v-for="item in social"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('feed.settings.stopSource.newSource.form.profile_id')" prop="profile_id">
        <el-input size="small" :placeholder="$t('feed.settings.stopSource.newSource.form.profile_placeholder')" v-model="sourceForm.profile_id"></el-input>
      </el-form-item>

      <el-divider></el-divider>

      <div class="user-footer">
        <el-button
          size="medium"
          type="primary"
          @click="handleAdd('sourceForm')">{{$t('feed.settings.stopSource.newSource.form.addButton')}}</el-button>
        <el-button
          size="medium"
          @click="resetForm('sourceForm')">{{$t('feed.settings.stopSource.newSource.form.cancelButton')}}</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  /*
    new stop-source component
  */

  // components
  import notify from "../../../../../../helpers/notify";

  // api
  import { addStopSourcesApi } from "../../../../../../api/feeds";

  export default {
    name: 'NewStopSource',
    data() {
      return {
        social: [
          {label: 'vk', value: '1'},
          {label: 'dz', value: '11'},
          {label: 'tw', value: '2'},
          {label: 'tb', value: '3'},
          {label: 'telegram', value: '5'},
          {label: 'сми', value: '4'},
        ],
        loading: false,
        sourceForm: {
          network_id: '1',
          profile_id: '',
        },
        rules: this.$t('feed.settings.stopSource.newSource.rules'),
      };
    },
    methods: {
      handleAdd(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;

            let params = {
              thread_id: this.$route.params.threadId,
              profile_id: this.sourceForm.profile_id,
              network_id: this.sourceForm.network_id,
            };

            addStopSourcesApi(params).then(resp => {
              this.$emit('updateSources', resp.data);
              notify.call(this, this.$t('feed.settings.stopSource.newSource.notify.add'), "success");
              this.$refs[formName].resetFields();
              this.loading = false;
            });
          } else {
            this.loading = false;
            notify.call(this, this.$t('feed.settings.stopSource.newSource.notify.error'), "error");
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
  };
</script>

<style>
  .stop-source-drawer__content {
    margin: 0 15px 0 15px;
    font-family: "Roboto", "Arial", sans-serif;
  }
  .stop-source-drawer__title {
    padding: 0;
    margin: 0;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 14px;
    color: #5E6D82;
  }
</style>
